import { useState } from 'react';
import type { Parsed } from '~/utils/parsed';

export function useInlineEdit<T>(
  parse: (raw: string) => Parsed<T>,
  save: (value: T) => Promise<boolean>
) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const open = () => {
    setHasError(false);
    setIsOpen(true);
  };

  const close = () => {
    setHasError(false);
    setIsOpen(false);
  };

  const submit = async (raw: string) => {
    const parsed = parse(raw);
    if (!parsed.valid) {
      setHasError(true);
      return;
    }
    setHasError(false);
    setIsSaving(true);
    try {
      if (await save(parsed.value)) {
        setIsOpen(false);
      }
    } finally {
      setIsSaving(false);
    }
  };

  return { isOpen, hasError, isSaving, open, close, submit };
}
